var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var ClientSettingsModel;
  return ClientSettingsModel = (function(_super) {

    __extends(ClientSettingsModel, _super);

    function ClientSettingsModel() {
      ClientSettingsModel.__super__.constructor.apply(this, arguments);
    }

    ClientSettingsModel.prototype.pathRoot = core.getConfig().apiPrefix + 'clientsettings.json';

    ClientSettingsModel.prototype.defaults = function() {
      return {
        clientId: null,
        sendEmailNotificationForReceiptFiled: null,
        sendEmailNotificationForComments: null,
        sendEmailNotificationToTaxAccountants: null
      };
    };

    return ClientSettingsModel;

  })(BaseModel);
});
